import { PromptResponse } from './apiService';
import { getApiUrl } from '../../../config/api';
import { handleAPIError } from '../../../services/apiErrorHandler';

const getAuthHeaders = () => {
  const token = localStorage.getItem('authToken');
  return {
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};

export const analyzeVideo = async (
  video: File, 
  userIdea: string, 
  attributes: string, 
  contextType: string,
  projectId?: string
): Promise<PromptResponse> => {
  const formData = new FormData();
  formData.append('video', video);
  formData.append('userIdea', userIdea);
  formData.append('attributes', attributes);
  formData.append('contextType', contextType);
  if (projectId) {
    formData.append('projectId', projectId);
  }

  const response = await fetch(getApiUrl('/prompt-generator/analyze-video'), {
    method: 'POST',
    headers: getAuthHeaders(),
    body: formData,
  });

  if (!response.ok) {
    await handleAPIError(response);
  }

  return response.json();
};

export const analyzeImage = async (
  image: File, 
  userIdea: string, 
  attributes: string, 
  contextType: string,
  projectId?: string
): Promise<PromptResponse> => {
  const formData = new FormData();
  formData.append('image', image);
  formData.append('userIdea', userIdea);
  formData.append('attributes', attributes);
  formData.append('contextType', contextType);
  if (projectId) {
    formData.append('projectId', projectId);
  }

  const response = await fetch(getApiUrl('/prompt-generator/analyze-image'), {
    method: 'POST',
    headers: getAuthHeaders(),
    body: formData,
  });

  if (!response.ok) {
    await handleAPIError(response);
  }

  return response.json();
};
